export default function getTotalWeekFromYear(year) {
    const date = new Date(year, 0, 1);
    const isLeap = new Date(year, 1, 29).getMonth() === 1;
    if (date.getDay() === 4 || (isLeap && date.getDay() === 3)) {
        return 53;
    }
    return 52;
}
